import { render, staticRenderFns } from "./FeedBackInclusaoFutura.vue?vue&type=template&id=583ca361&scoped=true"
import script from "./FeedBackInclusaoFutura.vue?vue&type=script&lang=js"
export * from "./FeedBackInclusaoFutura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ca361",
  null
  
)

export default component.exports